const NAMESPACE = "editProjectBase";

const KEYS = {
    adminConfirmSaveDialogTitle: "adminConfirmSaveDialogTitle",
    adminConfirmSaveDialogMessage: "adminConfirmSaveDialogMessage"
};

const MESSAGES = {
    [KEYS.adminConfirmSaveDialogTitle]: {
        value: "Confirm Save",
        comment: "Title for confirmation dialog on admin page that save is required"
    },
    [KEYS.adminConfirmSaveDialogMessage]: {
        value: "Changes need to be saved before continuing. Do you wish to save and continue?",
        comment: "Confirmation dialog message asking user to confirm save before continuing"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
